import navigationAction from "utils/redux/action/navigation";
import resumeAction from "utils/redux/action/resume";

export const NAVIGATION_SET_MENU = navigationAction.SET_MENU;
export const NAVIGATION_TOGGLE_DRAWER = navigationAction.TOGGLE_DRAWER;
export const RESUME_SET_TYPE = resumeAction.SET_TYPE;
export const RESUME_TOGGLE_DIALOG = resumeAction.TOGGLE_DIALOG;
